export default function () {
    return (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M18.7559 16.7869C19.1132 15.9258 19.3105 14.9828 19.3105 13.9944V5.7881L11.8123 3.37305L4.31467 5.7881V13.9944C4.26662 20.362 12.1339 23.7183 16.8175 19.4929"
                stroke="url(#paint0_linear_725_2182)"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.8944 8.84173C12.6833 7.62401 10.8651 7.39106 9.42023 8.14082L10.9454 9.67427L9.29339 11.3353L7.76824 9.80181C7.02255 11.254 7.25475 13.0826 8.46535 14.3003C9.60384 15.4445 11.2783 15.7181 12.6751 15.1242L17.4909 19.9667C18.054 20.5329 18.967 20.5324 19.5301 19.9667C20.0932 19.4005 20.0932 18.4826 19.5301 17.9165L14.7143 13.0744C15.3045 11.67 15.0329 9.98642 13.8944 8.84173Z"
                stroke="url(#paint1_linear_725_2182)"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <defs>
                <linearGradient id="paint0_linear_725_2182" x1="19.5" y1="4.68555" x2="7" y2="22.1855" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FBD996" />
                    <stop offset="1" stopColor="#CB9755" />
                </linearGradient>
                <linearGradient id="paint1_linear_725_2182" x1="15.4999" y1="5.68555" x2="13.6471" y2="20.3912" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F9D693" />
                    <stop offset="1" stopColor="#D19F5D" />
                </linearGradient>
            </defs>
        </svg>
    );
}
